import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Message = lazy(() => import('../../container/message'));

const MessageRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/message`} component={Message}/>
        </Switch>
    );
};

export default MessageRoutes;
